<template>
  <div>
    <music-knowledge-wrapper :showStbClose="isSTB">
      <div
        class="theory-wrapper orange-loading"
        :class="{ 'stb-style': deviceType === 'stb' }"
        v-loading="wrapperLoading"
        element-loading-text="资源加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <div class="theory-left" :class="{active: menuShow}" ref="theoryLeft">
          <el-tree
            ref="tree"
            node-key="id"
            class="theory-tree no-transition"
            :class="{'transition-none': transitionNone}"
            :empty-text="wrapperLoading ? '加载中' : '暂无数据'"
            :data="treeData"
            :current-node-key="activeTreeId"
            :render-after-expand="false"
            :default-expanded-keys="activeTreeId ? [ activeTreeId ] : []"
            @node-click="handleTreeNodeClick"
          >
            <div class="custom-tree-node" :ref="'treeNode' + data.id" :class="{ 'active': activeTreeId === data.id }" slot-scope="{ data }">
              <span class="name">{{ data.name }}</span>
            </div>
          </el-tree>
        </div>
        <div class="theory-right">
          <div
            class="theory-content"
            ref="theoryContent"
            v-loading="contentLoading"
            element-loading-text="资源加载中..."
            element-loading-spinner="el-icon-loading"
          >
            <div :class="'fontType-' + contentFontSize">
              <mavon-editor
                v-model="content"
                :toolbarsFlag="false"
                :subfield="false"
                :shortCut="false"
                :autofocus="false"
                defaultOpen="preview"
                previewBackground="rgba(225, 249, 227, 0)"
                boxShadowStyle="0 0 0 0 rgba(0, 0, 0, 0)"
                :imageClick="handleMarkdownImageClick"
              />
            </div>
          </div>
          <div class="page">
            <el-button @click="handleChangeMenuShow" type="text" class="menu-btn">目录</el-button>
            <div class="page-button">
              <img src="../../../assets/images/theory/last.png" @click="handleChangePage(0)">
              <img src="../../../assets/images/theory/next.png" @click="handleChangePage(1)">
            </div>
            <!-- 搜索内容 begin -->
            <div class="search-bar" @click="showSearch">
              <img src="../../../assets/images/theory/search.png" />
              <span>搜索</span>
            </div>
          </div>
          <div class="music-knowledge-detail-slide">
            <div class="slide-icon" style="font-size: 24px;" @click="handleContentFontSizeClick(1)">A</div>
            <div class="slide">
              <el-slider
                :show-tooltip="false"
                v-model="contentFontSize"
                :step="1"
                :min="1"
                :max="11"
                vertical
                height="200px"
                show-stops
              />
            </div>
            <div class="slide-icon" style="font-size: 18px;" @click="handleContentFontSizeClick(0)">A</div>
          </div>
        </div>
      </div>
    </music-knowledge-wrapper>
    <el-drawer
      title="搜索乐理知识"
      :visible.sync="searchVisible"
      :custom-class=" deviceType === 'stb' ? 'theory-drawer stb-style' : 'theory-drawer' "
    >
      <div class="theory-search">
        <el-input placeholder="搜索乐理知识" v-model="searchValue" class="music-knowledge-search-input" clearable >
          <el-button slot="append" type="primary" icon="el-icon-search" @click="handleSearch" :loading="searchLoading">搜索</el-button>
        </el-input>
        <div class="theory-search-content">
          <div v-show="serachFinish && searchList.length === 0" class="no-data">
            <div class="el-icon-collection"></div>
            <h4>未找到相关乐理知识</h4>
          </div>
          <div v-show="searchText" class="search-text">包含“{{searchText}}”的小节：</div>
          <div
            v-for="item in searchList"
            :key="item.id"
            class="item"
            :class="{ active: activeTreeId === item.id }"
            @click="handleSearchItemClick(item)"
          >
            <img src="../../../assets/images/theory/theory-item.png" />
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import MusicKnowledgeWrapper from '@/components/preview/MusicKnowledgeWrapper'
import { queryMusicTheories, queryMusicTheoryDetail } from '@/services'

export default {
  name: 'MusicKnowledgeTheory',
  components: { MusicKnowledgeWrapper },
  data () {
    return {
      content: '',
      wrapperLoading: false,
      contentLoading: false,
      menuShow: true,
      contentFontSize: 5,
      isSTB: false,
      treeIdList: [],
      treeData: null,
      activeTreeId: null,
      searchValue: '',
      searchText: '',
      searchVisible: false,
      searchLoading: false,
      serachFinish: false,
      transitionNone: false,
      searchList: []
    }
  },
  methods: {
    async queryTreeData () {
      this.wrapperLoading = true
      const res = await queryMusicTheories({ per_page: 999 })
      let resData = res.data

      let treeIdList = []

      // 筛选第一级
      const firstLevel = resData.filter(item => item.pid === 0 || !item.pid)
      resData = this._.difference(resData, firstLevel) // 删除已经查出来的数据

      const secondLevel = firstLevel.map(firstLevelItem => {
        firstLevelItem.level = 1

        // 插入第一层Id
        treeIdList.push(firstLevelItem.id)

        // 筛选第二级
        const children = resData.filter(secondLevelItem => secondLevelItem.pid === firstLevelItem.id)
        resData = this._.difference(resData, children) // 删除已经查出来的数据

        // 筛选第三级
        firstLevelItem.children = children.map(secondLevelItem => {
          // 插入第二层Id
          treeIdList.push(secondLevelItem.id)
          secondLevelItem.level = 2
          const secondLevelChildren = resData.filter(thirdLevelItem => thirdLevelItem.pid === secondLevelItem.id)
          resData = this._.difference(resData, secondLevelChildren) // 删除已经查出来的数据

          // 插入第三层Id
          const thirdLevelIds = secondLevelChildren.map(item => item.id)
          treeIdList = treeIdList.concat(thirdLevelIds)

          secondLevelItem.children = secondLevelChildren
          return secondLevelItem
        })
        return firstLevelItem
      })

      this.treeIdList = treeIdList
      this.treeData = secondLevel

      this.$nextTick(() => {
        this.wrapperLoading = false
      })
    },
    async queryTheoryDetail () {
      this.contentLoading = true
      const res = await queryMusicTheoryDetail(this.activeTreeId)
      this.content = res.data.content || ''
      this.$refs.theoryContent.scrollTop = 0
      this.$nextTick(() => {
        this.contentLoading = false
      })
    },
    handleTreeNodeClick (data, node) {
      this.activeTreeId = data.id
    },
    handleChangePage (type) {
      if (this.contentLoading) { return }
      const activeTreeIdIndex = this.treeIdList.findIndex(item => item === this.activeTreeId)
      // 上一页
      if (type === 0) {
        this.activeTreeId = activeTreeIdIndex > 0 ? this.treeIdList[activeTreeIdIndex - 1] : this.activeTreeId
      } else {
        this.activeTreeId = activeTreeIdIndex + 1 < this.treeIdList.length ? this.treeIdList[activeTreeIdIndex + 1] : this.activeTreeId
      }
    },
    handleChangeMenuShow () {
      this.menuShow = !this.menuShow
    },
    async handleSearch () {
      if (!this.searchValue) { return }
      this.searchLoading = true
      const res = await queryMusicTheories({ per_page: 20, content: this.searchValue })
      this.searchList = res.data
      this.searchText = res.data.length > 0 ? this.searchValue : ''
      this.$nextTick(() => {
        this.searchLoading = false
        this.serachFinish = true
      })
    },
    // 调整字体大小
    handleContentFontSizeClick (type) {
      if (type && this.contentFontSize < 11) {
        this.contentFontSize = this.contentFontSize + 1
        return
      }
      if (!type && this.contentFontSize > 1) {
        this.contentFontSize = this.contentFontSize - 1
      }
    },
    async init () {
      this.isSTB = this.$route.query.deviceType === 'stb'
      await this.queryTreeData()
      const activeTreeId = parseInt(this.$route.query.id)
      if (activeTreeId) {
        this.activeTreeId = activeTreeId
        this.menuShow = false
      } else {
        this.activeTreeId = 3
      }
    },
    showSearch () {
      this.searchVisible = true
    },
    handleSearchItemClick (item) {
      this.activeTreeId = item.id
      this.$nextTick(() => {
        const offsetTop = this.$refs[`treeNode${item.id}`].offsetTop
        if (offsetTop === 0) {
          this.transitionNone = true
          setTimeout(() => {
            this.$refs.theoryLeft.scrollTop = this.$refs[`treeNode${item.id}`].offsetTop
            this.transitionNone = false
          }, 60)
        } else {
          this.$refs.theoryLeft.scrollTop = offsetTop
        }
      })
    },
    handleMarkdownImageClick (item) {
      // 初始化 viewerjs
      const viewer = new Viewer(item, {
        title: false,
        navbar: false,
        toolbar: {
          zoomIn: 4,
          zoomOut: 4,
          play: false,
          next: false,
          prev: false
        },
        keyboard: false,
        transition: false
      })
      viewer.show()
      return false
    }
  },
  watch: {
    activeTreeId (value) {
      const currentNode = this.$refs.tree.getNode(value)
      if (currentNode.isLeaf) {
        this.queryTheoryDetail()
      } else {
        this.content = `### ${currentNode.data.name}`
      }
    }
  },
  computed: {
    ...mapState(['deviceType'])
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss">
.theory-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .theory-tree {
    background: none;
    color: #846349;
    .name {
      font-size: 18px;
      flex: 1;
      width: 0;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .custom-tree-node {
      flex: 1;
      width: 0;
      height: 36px;
      display: flex;
      align-items: center;
      &.active {
        color: #ff790e;
      }
    }
    .el-tree-node__content {
      height: 36px;
      &:hover {
        background: none;
      }
    }
    .el-tree-node:focus>.el-tree-node__content {
      background: none;
    }
    .el-tree-node__expand-icon {
      display: block;
      margin: 0 6px 0 10px;
      width: 18px;
      height: 18px;
      background: url("~@/assets/images/theory/theory-folder.png") no-repeat center center;
      &.expanded {
        transform: none;
        background: url("~@/assets/images/theory/theory-folder-open.png") no-repeat center center;
      }
      &::before {
        display: none;
      }
      &.is-leaf {
        background: url("~@/assets/images/theory/theory-item.png") no-repeat center center;
      }
    }
  }
  .theory-left {
    width: 0;
    height: 100%;
    flex: 0 0 320px;
    box-sizing: border-box;
    padding: 18px 18px 28px 10px;
    overflow: auto;
    margin-right: -290px;
    opacity: 0;
    /* transition: all ease-in-out 200ms; */
    &.active {
      opacity: 1;
      margin-right: 0;
    }
  }
  .theory-right {
    width: 0;
    flex: 1;
    box-sizing: border-box;
    padding: 24px 70px 80px 0;
    position: relative;
    .v-note-wrapper {
      background: none;
    }
    .menu-btn {
      color: #00b4ff;
      font-size: 18px;
      height: 32px;
      line-height: 28px;
      border-bottom: 2px solid #00b4ff;
      padding: 2px 0;
      border-radius: 0;
    }
    .theory-content {
      width: 100%;
      height: 100%;
      overflow: auto;
      border: 2px solid #fcd168;
      border-radius: 12px;
      box-sizing: border-box;
      padding: 10px 0;
      background: #fff9e3;
      h3 {
        text-align: center;
        line-height: 1.8em;
        color: #4d2d15;
        margin-top: 0;
      }
      p {
        text-indent: 2em;
        color: #795439;
      }
    }
    .page {
      left: 0;
      right: 70px;
      display: flex;
      bottom: 19px;
      position: absolute;
      justify-content: space-between;
      .page-button {
        height: 42px;
        img {
          margin: 0 24px;
        }
      }
    }
    .music-knowledge-detail-slide {
      position: absolute;
      right: 18px;
      width: 40px;
      top: 28px;
      .slide-icon {
        width: 38px;
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #b15f27;
        font-weight: 500;
      }
    }
  }
  @for $i from 1 through 11
  {
      .fontType-#{$i}
      {
        p {
          font-size: 18px + $i * 2px;
        }
        h3 {
          font-size: 22px + $i * 2px;
        }
      }
  }
  .search-bar {
    z-index: 11;
    height: 40px;
    display: flex;
    border-radius: 20px;
    border: 2px solid #fcd168;
    width: 240px;
    background: #fff9e3;
    justify-content: center;
    align-items: center;
    color: #baa494;
    font-size: 20px;
    img {
      margin-right: 10px;
    }
    .search-submit {
      background: #ff8e43;
      border-color: #ff8e43;
      color: #fff;
      border-radius: 0 4px 4px 0;
    }
  }
}
.theory-drawer {
  background: #fff9e3;
  overflow: auto;
  .theory-search {
    box-sizing: border-box;
    padding: 0 20px 20px;
    .music-knowledge-search-input {
      width: 100%;
    }
    .el-input__inner {
      border-radius: 20px 0 0 20px;
    }
    .el-input-group__append {
      background: #ff8e43;
      border-color: #ff8e43;
      color: #fff;
      border-radius: 0 4px 4px 0;
      border-radius: 0 20px 20px 0;
    }
    .theory-search-content {
      .item {
        min-height: 36px;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #846349;
        &.active {
          color: #ff790e;
        }
        img {
          margin: 0 16px 0 10px;
        }
      }
    }
    .search-text {
      font-size: 16px;
      color: #72767b;
      margin: 16px 0 8px;
    }
    .no-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #af5d25;
      padding-top: 60px;
      div {
        font-size: 40px;
      }
      h4 {
        font-weight: normal;
        font-size: 18px;
      }
    }
  }
}
.transition-none {
  .collapse-transition {
    transition: none !important;
  }
}
@media screen and (width: 1920px) {
  .theory-wrapper.stb-style {
    .theory-left {
      flex: 0 0 520px;
      padding: 27px 27px 42px 15px;
      margin-right: -435px;
      &.active {
        opacity: 1;
        margin-right: 0;
      }
      .theory-tree {
        transform-origin: 0 0;
        transform: scale(1.5);
      }
    }
    .theory-right {
      padding: 36px 105px 120px 0;
      .menu-btn {
        font-size: 27px;
        height: 48px;
        line-height: 42px;
        border-bottom: 3px solid #00b4ff;
        padding: 3px 0;
      }
      .theory-content {
        border-radius: 18px;
        padding: 15px 0;
      }
      .page {
        right: 105px;
        bottom: 30px;
        .page-button {
          height: 63px;
          img {
            height: 63px;
            margin: 0 36px;
          }
        }
      }
      .music-knowledge-detail-slide {
        transform-origin: 0 0;
        transform: scale(1.5);
        right: 48px;
        top: 60px;
      }
    }
    @for $i from 1 through 11
    {
        .fontType-#{$i}
        {
          p {
            font-size: 28px + $i * 2px;
          }
          h3 {
            font-size: 34px + $i * 2px;
          }
        }
    }
    .search-bar {
      height: 60px;
      border-radius: 30px;
      border: 3px solid #fcd168;
      width: 360px;
      font-size: 30px;
      img {
        margin-right: 15px;
      }
      .search-submit {
        border-radius: 0 6px 6px 0;
      }
    }
  }

  .theory-drawer.stb-style {
    #el-drawer__title {
      margin-bottom: 24px;
      padding: 30px 30px 0;
      span {
        font-size: 24px;
      }
      .el-drawer__close-btn {
        font-size: 30px;
      }
    }
    .theory-search {
      padding: 0 30px 30px;
      .music-knowledge-search-input {
        width: 344px;
        transform-origin: 0 0;
        transform: scale(1.5);
      }
      .theory-search-content {
        .item {
          min-height: 54px;
          font-size: 27px;
          img {
            width: 18px;
            margin: 0 24px 0 15px;
          }
        }
      }
      .search-text {
        font-size: 24px;
        margin: 24px 0 12px;
      }
      .no-data {
        padding-top: 90px;
        div {
          font-size: 60px;
        }
        h4 {
          font-size: 27px;
        }
      }
    }
  }
}
</style>
